// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import { store } from './store'
import { auth } from './firebaseInit'
import AsyncComputed from 'vue-async-computed'
// import Avatar from 'vue-avatar-component'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import './assets/css/components.css'
import moment from 'vue-moment'
import Croppa from 'vue-croppa'
import RunScripts from './scripts/RunScripts'
import currency from 'v-currency-field'
import 'v-currency-field/dist/index.css'

Vue.use(Croppa)
Vue.use(currency)

Vue.use(Vuetify, {
  theme: {
    primary: '#29a6d3',
    secondary: '#424242',
    tertiary: '#467e92',
    lightGrey: '#d6d6d6',
    NotStarted: '#9e9e9e',
    Started: '#006064',
    OnHold: '#fe9700',
    PastDue: '#F44336',
    Flagged: '#E91E63',
    Completed: '#4CAF50'
  }
})

Vue.use(AsyncComputed)
Vue.use(require('vue-moment'))
Vue.config.productionTip = false
let loaded = false

// Enable Dev Tools
Vue.config.devtools = false

auth.onAuthStateChanged(function (user) {
  if (!loaded) {
    loaded = true
    /* eslint-disable no-new */
    new Vue({
      el: '#app',
      router,
      store,
      created () {
        this.$store.dispatch('clientSettings', { baseUrl: 'https://app.pool-tracker.com' })
        this.$store.dispatch('loadDefaultFilters')
        // Run custom scripts if needed
        RunScripts()
        // check for authentication token
        auth.onAuthStateChanged(user => {
          if (user) {
            this.$store.dispatch('autoSignIn', user)
            this.$store.dispatch('personalNotes', user.uid)
          }
        })
        // get all contacts for search
        this.$store.dispatch('getUsers')
        this.$store.dispatch('getVendorList')
        this.$store.dispatch('getBuilders')
        this.$store.dispatch('getRoles', 'Admin')
        // get dropdowns
        this.$store.dispatch('getDropDowns')
      },
      components: {
        App,
        moment
      },
      template: '<App/>'
    })
  }
})

Vue.filter('formatSize', function (size) {
  if (size > 1024 * 1024 * 1024 * 1024) {
    return (size / 1024 / 1024 / 1024 / 1024).toFixed(2) + ' TB'
  } else if (size > 1024 * 1024 * 1024) {
    return (size / 1024 / 1024 / 1024).toFixed(2) + ' GB'
  } else if (size > 1024 * 1024) {
    return (size / 1024 / 1024).toFixed(2) + ' MB'
  } else if (size > 1024) {
    return (size / 1024).toFixed(2) + ' KB'
  }
  return size.toString() + ' B'
})



// WEBPACK FOOTER //
// ./src/main.js